import React from 'react';
import { getVehicles, getFleets } from '../api/vehicles';

export default function Dashboard({ setView }) {
  const [stats, setStats] = React.useState({
    totalVehicles: 0,
    activeVehicles: 0,
    totalFleets: 0,
  });
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    async function loadStats() {
      try {
        const [vehicles, fleets] = await Promise.all([
          getVehicles(),
          getFleets(),
        ]);

        const activeCount = vehicles.filter((v) => v.status === 'active').length;

        setStats({
          totalVehicles: vehicles.length,
          activeVehicles: activeCount,
          totalFleets: fleets.length,
        });
      } catch (err) {
        console.error('Failed to load stats:', err);
      } finally {
        setLoading(false);
      }
    }

    loadStats();
  }, []);

  if (loading) {
    return <div className="loading">Loading dashboard...</div>;
  }

  return (
    <div>
      <h2 style={{ marginBottom: '1.5rem', fontSize: '1.75rem' }}>Dashboard</h2>
      <div className="dashboard">
        <div className="dashboard-card">
          <h3>Total Vehicles</h3>
          <div className="value">{stats.totalVehicles}</div>
        </div>
        <div className="dashboard-card">
          <h3>Active Vehicles</h3>
          <div className="value">{stats.activeVehicles}</div>
        </div>
        <div className="dashboard-card">
          <h3>Total Fleets</h3>
          <div className="value">{stats.totalFleets}</div>
        </div>
      </div>
      <div style={{ marginTop: '2rem' }}>
        <button className="btn-primary" onClick={() => setView('vehicles')} style={{ maxWidth: '300px' }}>
          View All Vehicles
        </button>
      </div>
    </div>
  );
}
